module.exports = __webpack_public_path__ + "static/media/mint.a72f3f3b.gif";